module.exports = __webpack_public_path__ + "static/media/cv-barbara-eng.4e141352.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assents/cv-barbara-eng.pdf
// module id = 297
// module chunks = 0